import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { AdminMutationKey } from '../../../keys'
import {
	OperatorDataResponse,
	CreateOperatorRequest,
} from '@/modules/manage-operator/types'
import { createOperator } from '../../services'

export default function useMutationCreateOperator(
	props?: UseBaseMutationOptions<OperatorDataResponse, CreateOperatorRequest>,
) {
	return useMutation({
		mutationKey: [AdminMutationKey.CreateOperator],
		mutationFn: (params) => createOperator(params),
		...props,
	})
}
